import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'
import {
    baseUrl
} from '@/config/env';


export const shipmentProductDetailOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: false,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    labelWidth: '160',
    //menuType:'menu',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "商品名称",
            prop: "productName",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '品牌',
            prop: 'brandName',
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: 'SKU',
            prop: 'skuValue',
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: '产品单价',
            prop: 'price',
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: '出货数量',
            prop: 'number',
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: '出货总金额',
            prop: 'totalMoney',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '出货人',
            prop: 'createBy',
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "出货时间",
            prop: "shipmentTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "出货时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                console.log(row)
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};